import { deleteReq, get, post } from './index';

export const saveScore = param => post('/api/v1/submissions/questionnaire', param);
// "readinessScore": 42,
//     "guideRobotScore": 65,
//     "medDeliveryRobotScore": 80,
//     "specimenDeliveryRobotScore": 100,
//     "docDeliveryRobotScore": 50

export const submitInquiry = param => post('/api/v1/submissions/inquiry', param);

export const getSubmissions = param => get('/api/v1/submissions', param);

export const getSubmission = param => get(`/api/v1/submissions/${param.submissionNum}`);

export const deleteSubmissions = ({ submissionNums, ...param }) =>
    deleteReq(`/api/v1/submissions/${submissionNums}`, { params: param });

export const downloadSubmissions = ({ submissionNums, ...param }) =>
    post(`/api/v1/submissions/excel${submissionNums ? '/' + submissionNums : ''}`, null, {
        responseType: 'blob',
        params: param,
    });
